import React from 'react';
import styles from './Skills.module.css';

interface SkillGroup {
  category: string;
  icon:     string;
  color:    string;
  skills:   string[];
}

const SKILL_GROUPS: SkillGroup[] = [
  {
    category: 'Backend',
    icon: '⚙️',
    color: '#00e5ff',
    skills: ['Java SE/EE', 'Spring Boot', 'Node.js', 'Express', 'TypeScript', 'Hibernate ORM', 'JUnit / Mockito', 'JWT / SSO', 'Microservices', 'Event-Driven Architecture', 'REST API Design'],
  },
  {
    category: 'Frontend',
    icon: '🖥️',
    color: '#a78bfa',
    skills: ['React', 'Angular', 'HTML / CSS / SCSS', 'rxjs', 'Reactive Programming', 'Bootstrap', 'JSON / XML'],
  },
  {
    category: 'Database',
    icon: '🗄️',
    color: '#34d399',
    skills: ['PostgreSQL', 'MySQL', 'Oracle', 'SQL Server', 'MongoDB', 'Redis', 'MariaDB'],
  },
  {
    category: 'Cloud & DevOps',
    icon: '☁️',
    color: '#f59e0b',
    skills: ['AWS EC2 / VPC / S3', 'AWS SQS / SNS', 'AWS ECS / ELB', 'AWS RDS / CloudWatch', 'AWS IAM / Route53', 'Docker', 'Jenkins (CI/CD)', 'Linux / Ubuntu', 'Git / GitHub / GitLab'],
  },
  {
    category: 'Messaging & Streaming',
    icon: '📨',
    color: '#f87171',
    skills: ['Apache Kafka', 'AWS SQS', 'RabbitMQ', 'WebSocket'],
  },
  {
    category: 'Monitoring & AI Tools',
    icon: '📊',
    color: '#60a5fa',
    skills: ['New Relic', 'Grafana', 'CloudWatch', 'LaunchDarkly', 'ServiceNow', 'JIRA / Trello', 'Postman', 'IntelliJ IDEA', 'VS Code', 'ChatGPT / GitHub Copilot', 'Claude AI', 'Cursor'],
  },
];

export default function Skills(): React.ReactElement {
  return (
    <section id="skills" className={styles.section}>
      <div className={styles.inner}>
        <h2 className={styles.heading}>
          <span className={styles.headingNum}>03.</span>
          Skills &amp; Tech
          <div className={styles.headingLine} />
        </h2>

        <div className={styles.grid}>
          {SKILL_GROUPS.map((group) => (
            <div
              key={group.category}
              className={styles.card}
              style={{ '--hover-color': group.color } as React.CSSProperties}
              onMouseEnter={(e) => (e.currentTarget.style.borderTopColor = group.color)}
              onMouseLeave={(e) => (e.currentTarget.style.borderTopColor = 'transparent')}
            >
              <div className={styles.cardHeader}>
                <span className={styles.cardIcon} aria-hidden="true">{group.icon}</span>
                <span className={styles.cardTitle} style={{ color: group.color }}>
                  {group.category}
                </span>
              </div>
              <div className={styles.pills}>
                {group.skills.map((skill) => (
                  <span
                    key={skill}
                    className={styles.pill}
                    style={{
                      background: `${group.color}10`,
                      border: `1px solid ${group.color}20`,
                    }}
                  >
                    {skill}
                  </span>
                ))}
              </div>
            </div>
          ))}
        </div>

        {/* Certification */}
        <div className={styles.certBadge}>
          <span className={styles.certIcon} aria-hidden="true">🏆</span>
          <div>
            <p className={styles.certTitle}>AWS Certified Solutions Architect — Associate</p>
            <a
              className={styles.certLink}
              href="https://www.credly.com/badges/2d4328fb-fd42-43cc-8ed7-49cace463770/public_url"
              target="_blank"
              rel="noopener noreferrer"
            >
              Verify on Credly →
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
